<template>
  <div>
    <DxDataGrid
      :data-source="store"
      :show-borders="false"
      :show-column-lines="false"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :column-auto-width="true"
      :show-column-headers="false"
      :show-colon="false"
      :remote-operations="false"
      :hover-state-enabled="false"
      :show-row-lines="false"
      :row-alternation-enabled="false"
      :no-data-text="$t('noDataText')"
      class="custom-grid custom-grid-material-list"
      @toolbar-preparing="onToolbarPreparing($event)"
    >
      <DxScrolling mode="standard" />

      <DxPaging :page-size="5" />

      <DxPager
        :show-page-size-selector="true"
        :allowed-page-sizes="[5, 10, 20]"
        :show-info="true"
        info-text="{2} items"
        :visible="true"
      />

      <DxSearchPanel :visible="true" :placeholder="$t('search')" />

      <DxColumn
        data-field="CodArticulo"
        :caption="$t('article')"
        :allow-sorting="true"
        :fixed="true"
        fixed-position="left"
        :allow-header-filtering="false"
      />
      <DxColumn
        data-field="Descripcion"
        :caption="$t('description')"
        :allow-sorting="true"
        :fixed="true"
        fixed-position="left"
        :allow-header-filtering="false"
      />
      <DxColumn
        :buttons="updatedEditButtons"
        :fixed="true"
        fixed-position="right"
        type="buttons"
        width="80"
      />
    </DxDataGrid>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxSearchPanel,
  DxPager,
  DxPaging,
  DxScrolling,
} from 'devextreme-vue/data-grid';
import { mapActions } from 'vuex';

export default {
  name: 'MaterialList',
  components: {
    DxDataGrid,
    DxColumn,
    DxSearchPanel,
    DxPager,
    DxPaging,
    DxScrolling,
  },
  props: {
    store: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    updatedEditButtons() {
      return [
        {
          icon: 'add',
          onClick: this.viewAtc,
        },
      ];
    },
  },
  methods: {
    onToolbarPreparing(e) {
      const toolbarItems = e.toolbarOptions.items;
      toolbarItems.forEach((item) => {
        if (item.name === 'searchPanel') {
          item.location = 'before';
          item.options.width = 100;
        }
      });
    },
    onInit(e) {
      this.grid = e;
      Array.from(
        document.getElementsByClassName('dx-group-cell')
      ).forEach((el) => {
        el.innerHTML = el.innerHTML.split(':')[1].trim();
      });
    },
    viewAtc(e) {
      const data = [e.row.data].map((item) => {
        return {
          CodArticulo: item.CodArticulo,
          Descripcion: item.Descripcion,
          Cantidad: 1,
        };
      });
      this.setMaterialsSelected(data);
    },
    ...mapActions('materialRequest', ['setMaterialsSelected']),
  },
};
</script>
<style>
.custom-grid-material-list
  .dx-gridbase-container
  > .dx-datagrid-rowsview {
  background: var(--Secondary-Green-10, #fff);
}
.custom-grid-material-list .dx-datagrid-rowsview .dx-row {
  background: var(--Basic-White, #f2f8e2);
}
.custom-grid-material-list .dx-datagrid-pager {
  border-top: none !important;
  background: var(--Secondary-Green-10, #fff) !important;
}
.custom-grid-material-list .dx-datagrid-headers {
  background: var(--Secondary-Green-10, #f2f8e2) !important;
}
.custom-grid-material-list .dx-datagrid-header-panel {
  border-bottom: none !important;
  border-top: none !important;
}
</style>
